import { App } from 'BMapsSrc/BMapsApp';
import { JobTypes, fetchPropertyGroupWithJobman } from 'BMapsSrc/jobman';
import { ensureArray } from 'BMapsSrc/util/js_utils';

/**
 * Request MapList properties for a group of compounds.
 * @param {Array<import('BMapsModel').Compound} compoundsIn
 * @param {{
 *   trigger: function?,
 *   recalculate: boolean?,
 *   waitSleepMs?: number,
 *   checkResultsSeconds?: number,
 *   maxWaitMs?: number,
 * }} options
 * @returns {Promise<void>}
 */
export async function getMapLightProperties(
    compoundsIn,
    {
        trigger, recalculate, waitSleepMs, checkResultsSeconds, maxWaitMs,
    }={}
) {
    const compounds = ensureArray(compoundsIn);
    const uniqueCmpds = new Map();
    for (const cmpd of compounds) {
        if (!recalculate && cmpd.scopedProperties.hasScope(JobTypes.MAPLIGHT)) {
            continue;
        }
        const uniqueStructId = cmpd.getUniqueStructId();
        const smiles = cmpd.getUnnamedSmiles();
        if (!uniqueCmpds.has(uniqueStructId)) {
            uniqueCmpds.set(cmpd.getUniqueStructId(), { cmpd, smiles });
        }
    }

    if (uniqueCmpds.size === 0) {
        return;
    }

    const maplightData = [...uniqueCmpds.entries()].reduce((acc, [uniqueStruct, { smiles }]) => (
        { ...acc, [uniqueStruct]: { smiles } }
    ), {});

    const jobRequestData = {
        jobtype: JobTypes.MAPLIGHT,
        data: maplightData,
        stash: { recalculate },
    };

    // getValues is provided as an example, but it is not used
    // because the job integrateResults already applies the properties to the compounds.
    function getValues(results, cmpd) {
        const structId = cmpd.getUniqueStructId();
        const values = results.jobResults[structId];
        if (!values) {
            console.error(`No MapLight properties returned for ${cmpd.resSpec}`);
            return null;
        }
        return Object.entries(values).reduce((acc, [propName, value]) => ({
            ...acc, [propName]: { value },
        }));
    }
    function refreshItems(items) {
        return App.Workspace.getLatestCompounds(items);
    }
    await fetchPropertyGroupWithJobman(
        compounds,
        JobTypes.MAPLIGHT,
        jobRequestData,
        {
            trigger,
            refreshItems,
            waitSleepMs,
            checkResultsSeconds,
            maxWaitMs,
        }
    );
}
